<template>
  <span class="required-label">
    <span>{{ label }}</span><span v-if="required" class="required-asterisk" aria-hidden="true">&nbsp;*</span>
    <span v-if="required" class="sr-only">{{ $gt('(Pflichtfeld)') }}</span>
  </span>
</template>

<script setup lang="ts">
defineProps<{
  label: string
  required?: boolean
}>()
</script>

<style scoped>
.required-label {
  display: inline-flex;
  align-items: baseline;
}

.required-asterisk {
  color: rgb(var(--v-theme-error));
  font-weight: 600;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
